import { render } from "./TariffsIndividualCreate.vue?vue&type=template&id=f5328338&scoped=true&ts=true"
import script from "./TariffsIndividualCreate.vue?vue&type=script&lang=ts"
export * from "./TariffsIndividualCreate.vue?vue&type=script&lang=ts"

import "./TariffsIndividualCreate.vue?vue&type=style&index=0&id=f5328338&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5328338"]])

export default __exports__